import api from './api'
import auth from './auth'

export default {
  install (Vue) {
    Vue.use(api)
    Vue.use(auth)
  }
}
